import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { MyDeqErrorHandler } from "../../../core/errorHandler";
import { AppService } from "../../../service/app.service";
import { Utils } from "../../../shared/Utils";
import { BasePathController } from "../../components/base-path-component.component";
import { PagecontentSearchResultPage } from "./search-result.resourcebundle";

@Component({
  selector: "search-result",
  templateUrl: "./search-result.component.html",
})
export class SearchResultComponent extends BasePathController {
  openPanelArr = ["custom-panel-0"];
  errorsList: any[] = [];
  displayBackButton: boolean = false;

  /**
   * Parses the LISTAGG outfalls string "LAT|LNG;LAT|LNG" into an array
   * of { lat, lng } objects for use in the template.
   */
  parseOutfalls(outfalls: string): { lat: string; lng: string }[] {
    if (!outfalls) return [];
    return outfalls.split(';')
      .filter(o => o && o.trim().length > 0)
      .map(o => {
        const parts = o.split('|');
        return { lat: parts[0] || '', lng: parts[1] || '' };
      });
  }

  readonly accordionPanelName = "custom-panel-";
  activeIDS = this.accordionPanelName + "0";
  add_new_activeIDS = this.accordionPanelName + "0";

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected formBuilder: UntypedFormBuilder,
    public utils: Utils,
    protected appService: AppService,
    protected errorHandler: MyDeqErrorHandler,
    private router: Router
  ) {
    super(
      activatedRoute,
      formBuilder,
      utils,
      appService,
      errorHandler,
      new PagecontentSearchResultPage()
    );
    //this.setPageLoadServiceName("cgp");
    this.setPageLoadServiceURL("service/permit/cgp");
    this.utils.title = "STORMWATER CONSTRUCTION GENERAL PERMIT RESULTS";
  }

  /**
   * @whatItDoes - This method will call by @class BaseComponent @function ngOnInit method to set the form as per input received.
   */
  onGetResponse(getResponse: any): void {
    this.displayBackButton = true;
  }

  onGettError(errorObj: any): void {
    this.displayBackButton = true;
    super.onGettError(errorObj);
  }

  createForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  public beforeChange($event: NgbNavChangeEvent) {
    if ($event.nextId === false) {
      $event.preventDefault();
    }
  }

  returnToSearchCriteria() {
    // Reconstruct the original search params that were active on the approved-list
    // page before the user clicked VIEW. These were encoded as 'from*' params.
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const returnParams: any = {};

      if (queryParams["fromViewAll"] === "true") {
        // Came from View All — return to approved-list with no filters
        this.router.navigate(["/cgp", "approved-list"]);
        return;
      }
      // Came from a specific search — restore those filters
      if (queryParams["fromLtfid"])    returnParams["ltfid"]          = queryParams["fromLtfid"];
      if (queryParams["fromCompany"])  returnParams["companyname"]    = queryParams["fromCompany"];
      if (queryParams["fromFacility"]) returnParams["facilityname"]   = queryParams["fromFacility"];
      if (queryParams["fromCounty"])   returnParams["facilitycounty"] = queryParams["fromCounty"];

      this.router.navigate(["/cgp", "approved-list"], { queryParams: returnParams });
    }).unsubscribe();
  }
}
